import { requestTool } from "../../tools";

export const TreeService = {

    async getTreeNodesData(tableId) {

        //let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicTable/GetTableColumns";

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicTable/GetTableColumns";

        if (tableId) {

            _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicTable/GetTableColumns?_tableId=" + tableId;

        }

        return requestTool.getRequest(_url).then(res => {
            if (res) {
                return res.data;
            }
        })

    },

    async getLayerType(parentLayerType) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/LayerType/GetParentLayerType?layerType=" + parentLayerType;

        return requestTool.getRequest(_url).then(res => {

            return res.data;

        })

    },

    async addNewLayer(_data) {

        let _addUrl = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/Add";

        return requestTool.postRequest(_addUrl, _data).then(res => {
            if (res.success) {
                return res;
            }
        })

    },
    async getKatmantTypes() {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/LayerType/GetExistLayerType";

        return requestTool.getRequest(_url).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async clearLayerType() {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/LayerType/ClearLayerTypeTable";

        return requestTool.deleteRequest(_url, null).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async saveLayerType(_data) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/LayerType/Add";

        return requestTool.postRequest(_url, _data).then(res => {
            if (res) {
                return res;
            }
        })
    },
    async deleteLayer(_id) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/DeleteItem?_id=" + _id;

        return requestTool.deleteRequest(_url, null).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async deleteTreeTable() {
        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicTable/DeleteActiveTableUser";

        return requestTool.deleteRequest(_url).then(res => {
            if (res) {
                return res;
            }
        })
    },
    async getTreeTableColumns() {
        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicTable/GetTableColumns";

        return requestTool.getRequest(_url).then(res => {
            if (res) {
                return res;
            }
        })
    },
    async getColumnsTypes() {
        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicTable/GetColumnType";

        return requestTool.getRequest(_url).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async createTreeTable(data) {
        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicTable/Add";

        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        })

    },

    async addGeometry(data) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/UpdateItem";

        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async createGeometryFromChildren(data) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/CreateGeometryFromChildren";

        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async queryTable(data) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/DynamicTableQuery";

        if (data._tableId) {
            _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/DynamicTableQuery?_tableId=" + data._tableId;
        }

        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        })
    },
    async queryTableIdFromChild(id,isChildAll) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/GetAllChildFromId";

        if (id) {
            _url += "?id=" + id + "&isChildAll=" + isChildAll;
        }

        return requestTool.postRequest(_url).then(res => {
            if (res) {
                return res;
            }
        })
    },
    async updateLayer(data) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/UpdateItem";

        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async IntersectCheck(data) {
        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/IntersectRule";

        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        })
    },
    async GetChilIntersectRule(layerId, tableId) {
        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/GetChildIntersectRule?_id=" + layerId;

        if (tableId) {
            _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/GetChildIntersectRule?_id=" + layerId + "&tableId=" + tableId;

        }


        return requestTool.getRequest(_url).then(res => {
            if (res) {
                return res;
            }
        })
    },
    async GetTree() {
        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/GetActiveTableRecord";

        return requestTool.getRequest(_url).then(res => {

            if (res) {
                return res
            }
        })
    },
    async UpdateParentId(data) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/UpdateDraggedNodeParent";

        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        })
    },

    async GetLayersFromParentId(layerId) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/GetLayersFromParentId?_id=" + layerId;

        return requestTool.getRequest(_url).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async GetLayersFromQuery(data) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/GetLayersFromIdList";

        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async CreateLayerStructure(data) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/CreateLayerStructure";

        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async GetLayerStructure() {


        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/GetLayerStructure";

        return requestTool.getRequest(_url).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async GetLayerStructureByParentId(parentId) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/GetLayerStructureByParentId?_parentId=" + parentId;

        return requestTool.getRequest(_url).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async InsertLayerStructure(data) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/InsertLayerStructure";

        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async GetTreeAuthorization() {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/TreeAuthorization/GetAllAuthorizationForUser";

        return requestTool.getRequest(_url)
            .then(response => {

                if (response) {
                    return response;
                }
            }).catch(e => { console.log(e); });
    },
    async GetNeighborhoodInfo(_id) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/Bcs/GetAddressFromLayer?layerId=" + _id;


        return requestTool.getRequest(_url)
            .then(response => {

                if (response) {
                    return response;
                }
            }).catch(e => { console.log(e); });

    },
    async GetCities() {
        let _url = process.env.REACT_APP_ADDRESS_API + "api/Province/GetAll"

        return requestTool.postRequest(_url).then(res => {
            if (res) {
                return res;
            }
        }).catch(e => { console.log(e); });

    },
    async GetDistricts() {
        let _url = process.env.REACT_APP_ADDRESS_API + "api/District/GetAll"

        return requestTool.getRequest(_url).then(res => {
            if (res) {
                return res;
            }
        }).catch(e => { console.log(e); });

    },
    async GetNeigborhoods() {
        let _url = process.env.REACT_APP_ADDRESS_API + "api/Neighbourhood/GetAll"

        return requestTool.getRequest(_url).then(res => {
            if (res) {
                return res;
            }
        }).catch(e => { console.log(e); });

    },

    async GetIsochroneDraw(data) {

        let _url = process.env.REACT_APP_BMS_API + "Basic/Catchment";


        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        }).catch(e => { console.log(e); });


    },
    async DifferenceTwoGeometry(data) {

        let _url = process.env.REACT_APP_GEOMETRY_OPERATION_API_URL + `/api/GeometryOperation/Difference2`;


        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        }).catch(e => { console.log(e); });
    },
    async DifferenceTwoGeometryV2(data) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/GetDiffrenceFromWkt";


        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        }).catch(e => { console.log(e); });
    },
    async DivideAreaForNeighborhoods(id) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/ClientGetNeighborhoodIntersectByGeom?layerId=" + id;

        return requestTool.getRequest(_url).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async DeleteLayers(data) {
        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/DeleteLayerList";

        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        })


    },
    async DeleteLayersGeometry(data) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/DeleteGeometryByIdList";

        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        })


    },
    async GetDraftTables() {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicTable/GetDraftTables";

        return requestTool.getRequest(_url).then(res => {

            if (res) {
                return res;
            }


        });
    },
    async GetDraftTableRecors(tableId) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/GetDraftTableRecord?tableId=" + tableId;

        return requestTool.getRequest(_url).then(res => {

            if (res) {
                return res;
            }


        });

    },
    async DeleteRecordDraftTable(recordId, tableId) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/DeleteItem?_id=" + recordId + "&_tableId=" + tableId;

        return requestTool.deleteRequest(_url, null).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async queryTableDraft(data, tableId) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/DynamicTableQuery?_tableId=" + tableId;

        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        })
    },
    async DivideAreaForNeighborhoodsByTable(id, tableId) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/ClientGetNeighborhoodIntersectByGeom?layerId=" + id + "&tableId=" + tableId;

        return requestTool.getRequest(_url).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async GetIntersectLayersFromCoordinate(data) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/Bcs/GetIntersectLayersFromCoordinate?long_=" + data[0] + "&lat_=" + data[1];


        return requestTool.getRequest(_url).then(res => {
            if (res) {
                return res;
            }
        })

    },
    async GetActiveTreeTableName(tableId) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicTable/GetTableName";

        if (tableId) {

            _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicTable/GetTableName?tableId=" + tableId;

        }

        return requestTool.getRequest(_url).then(res => {
            if (res) {
                return res;
            }
        })

    },

    async GetStructureTreeRequireds(tableId) {
        return requestTool.getRequest(process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicTable/GetTreeStructureRequireds").then(res => {
            if (res) {
                return res;
            }
        });
    },
    
    async GetIntersectTableDataForLayerId(tableId, layerId) {

        return requestTool.postRequest(process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/GetIntersectTableData", {
            layerId: layerId,
            tableId:tableId
        }).then(res => {
            if (res) {
                return res;
            }
        });
    },
       
    async GetTableDetailSumarize(tableId, layerId,wkt) {

        return requestTool.postRequest(process.env.REACT_APP_DYNAMICTABLE_API_URL + "/Analysis/CalculateArea/CalculateArea", {
            wkt: wkt,
            tableId: tableId,
            layerId: layerId

        }).then(res => {
            if (res) {
                return res;
            }
        });
    },
    async GeometryAutoFixed(data) {
        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/AutoFixedGeometry";

        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        })
    },
    async GetLayersFromQueryToExport(data) {

        let _url = process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/GetLayersFromIdListToExport";

        return requestTool.postRequest(_url, data).then(res => {
            if (res) {
                return res;
            }
        })

    },
}